export default __webpack_public_path__ + "static/media/Season.ed6e1e11.svg";